import React from "react";

export default function InformationRibonMobile2Lines(props) {
  return (
    <div className="ribon-information-mobile-2-lines">
      <span style={{ paddingTop: "5px" }}>{props.infoLabel}:</span>
      <span style={{ paddingBottom: "5px" }}>{props.labelContent}</span>
    </div>
  );
}
